const { typeMounted, typeUnmounted } = require('consts/components');

/**
 *
 * @param
 * param1: Name Component
 *
 */
const componentIsMounted = (nameComponent) => {
  return {
    type: typeMounted(nameComponent),
    [`${typeMounted(nameComponent)}`]: true,
  };
};

const componentIsUnmounted = (nameComponent) => {
  return {
    type: typeUnmounted(nameComponent),
    [`${typeMounted(nameComponent)}`]: false,
  };
};

export default {
  componentIsMounted,
  componentIsUnmounted,
};
